import AnnouncementsIndex from "@/views/announcements/AnnouncementIndex.vue";
import AddAnnouncement from "@/views/announcements/AddAnnouncement.vue";
import EditAnnouncement from "@/views/announcements/EditAnnouncement.vue";

export default [
  {
    path: "/announcements",
    name: "announcements.index",
    component: AnnouncementsIndex,
    meta: { 
      requiresAuth: true,
      permission: 'announcements.display',
      title: "announcement.breadcrumbs.manageAnnouncements"
    },
    children: [
      {
        path: "create",
        name: "announcements.create",
        component: AddAnnouncement,
        meta: { 
          requiresAuth: true,
          permission: 'announcements.create',
          title: "announcement.breadcrumbs.addAnnouncement"
        }
      },
      {
        path: ":id/edit",
        name: "announcements.edit",
        component: EditAnnouncement,
        props: true,
        meta: { 
          requiresAuth: true,
          permission: 'announcements.update',
          title: "announcement.breadcrumbs.editAnnouncement"
        }
      }
    ]
  }
];
